module.exports = __webpack_public_path__ + "img/ic-faces.a7c97442.jpg";